import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: null,
  employeeCacheById: {},
};

const loggedInEmployeeSlice = createSlice({
  name: 'loggedInEmployee',
  initialState,
  reducers: {
    setLoggedInEmployee: (state, action) => {
      state.data = action.payload || null;
    },
    updateLoggedInEmployee: (state, action) => {
      const patch = action.payload || {};
      if (!state.data) {
        state.data = patch && Object.keys(patch).length ? { ...patch } : null;
        return;
      }

      const next = {
        ...state.data,
        ...patch,
      };

      // Deep-merge full employee object cache when provided
      if (patch.employeeDetails && typeof patch.employeeDetails === 'object') {
        const prevDetails = state.data?.employeeDetails || {};
        const incomingDetails = patch.employeeDetails || {};
        const mergedDetails = {
          ...(prevDetails || {}),
          ...(incomingDetails || {}),
        };

        if ((incomingDetails.managerID == null || incomingDetails.managerID === '') && prevDetails.managerID != null)
          mergedDetails.managerID = prevDetails.managerID;
        if ((incomingDetails.managerId == null || incomingDetails.managerId === '') && prevDetails.managerId != null)
          mergedDetails.managerId = prevDetails.managerId;
        if (incomingDetails.manager == null && prevDetails.manager != null) mergedDetails.manager = prevDetails.manager;

        const prevEwd = prevDetails.employeeWorkDetails;
        const incomingEwd = incomingDetails.employeeWorkDetails;
        if (incomingEwd === null && prevEwd != null) {
          mergedDetails.employeeWorkDetails = prevEwd;
        } else if (incomingEwd && typeof incomingEwd === 'object') {
          const mergedEwd = {
            ...(prevEwd && typeof prevEwd === 'object' ? prevEwd : {}),
            ...(incomingEwd || {}),
          };
          if ((incomingEwd.managerID == null || incomingEwd.managerID === '') && prevEwd?.managerID != null)
            mergedEwd.managerID = prevEwd.managerID;
          if ((incomingEwd.managerId == null || incomingEwd.managerId === '') && prevEwd?.managerId != null)
            mergedEwd.managerId = prevEwd.managerId;
          mergedDetails.employeeWorkDetails = mergedEwd;
        }

        const prevWd = prevDetails.workDetails;
        const incomingWd = incomingDetails.workDetails;
        if (incomingWd === null && prevWd != null) {
          mergedDetails.workDetails = prevWd;
        } else if (incomingWd && typeof incomingWd === 'object') {
          const mergedWd = {
            ...(prevWd && typeof prevWd === 'object' ? prevWd : {}),
            ...(incomingWd || {}),
          };
          if ((incomingWd.managerID == null || incomingWd.managerID === '') && prevWd?.managerID != null)
            mergedWd.managerID = prevWd.managerID;
          if ((incomingWd.managerId == null || incomingWd.managerId === '') && prevWd?.managerId != null)
            mergedWd.managerId = prevWd.managerId;
          mergedDetails.workDetails = mergedWd;
        }

        next.employeeDetails = mergedDetails;
      }

      // Keep cached employeeDetails in sync with top-level fields
      if (next.employeeDetails && typeof next.employeeDetails === 'object') {
        if (patch.nameEn !== undefined) next.employeeDetails.nameEn = patch.nameEn;
        if (patch.nameAr !== undefined) next.employeeDetails.nameAr = patch.nameAr;
        if (patch.employeeNo !== undefined) next.employeeDetails.employeeNo = patch.employeeNo;

        if (patch.employeeImage !== undefined) {
          // employee-by-id payload uses `image` key
          next.employeeDetails.image = patch.employeeImage;
        }
      }

      state.data = next;
    },
    upsertEmployeeCache: (state, action) => {
      const patch = action.payload || {};
      const id = patch?.id;
      if (!id) return;
      const prev = state.employeeCacheById?.[id] || {};
      state.employeeCacheById = {
        ...(state.employeeCacheById || {}),
        [id]: {
          ...prev,
          ...patch,
          updatedAt: Date.now(),
        },
      };
    },
    clearLoggedInEmployee: (state) => {
      state.data = null;
      state.employeeCacheById = {};
    },
  },
});

export const { setLoggedInEmployee, updateLoggedInEmployee, upsertEmployeeCache, clearLoggedInEmployee } =
  loggedInEmployeeSlice.actions;

export default loggedInEmployeeSlice.reducer;
